<div class="pm">
  <header class="pm__header">
    <div>
      <h1 class="pm__title">
        <span class="pm__title-icon">
          <i class="fa-solid fa-building-columns" aria-hidden="true"></i>
        </span>
        {{ 'PAYMENT_METHODS.TITLE' | translate }}
      </h1>
      <p class="pm__subtitle">{{ 'PAYMENT_METHODS.SUBTITLE' | translate }}</p>
    </div>
    @if (canWrite) {
      <button type="button" class="pm__btn pm__btn--primary" (click)="addNew()">
        <i class="fa-solid fa-plus" aria-hidden="true"></i>
        {{ 'PAYMENT_METHODS.ADD' | translate }}
      </button>
    }
  </header>

  @if (!canWrite) { <app-read-only-notice></app-read-only-notice> }

  @if (isLoading) {
    <p class="pm__state">{{ 'COMMON.LOADING' | translate }}</p>
  } @else if (hasError) {
    <div class="pm__state">
      <i class="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>
      <p>{{ 'PAYMENT_METHODS.ERROR_LOAD' | translate }}</p>
    </div>
  } @else {
    <div class="pm__layout">

      <!-- Peu de moyens, et durables : une liste suffit. -->
      <nav class="pm__list" [attr.aria-label]="'PAYMENT_METHODS.TITLE' | translate">
        @for (method of methods; track method.id) {
          <button type="button" class="pm__card"
                  [class.is-active]="draft?.id === method.id"
                  (click)="select(method)">
            <span class="pm__card-name">{{ method.labelFr }}</span>
            <span class="pm__card-code">{{ method.code }}</span>
            <span class="pm__card-flags">
              @if (method.isActive) {
                <span class="pm__flag pm__flag--on">{{ 'PAYMENT_METHODS.ONLINE' | translate }}</span>
              } @else {
                <span class="pm__flag pm__flag--off">{{ 'PAYMENT_METHODS.OFFLINE' | translate }}</span>
              }
              @if (isIncomplete(method)) {
                <span class="pm__flag pm__flag--warn">{{ 'PAYMENT_METHODS.INCOMPLETE' | translate }}</span>
              }
            </span>
          </button>
        }
        @if (methods.length === 0) {
          <p class="pm__state">{{ 'PAYMENT_METHODS.EMPTY' | translate }}</p>
        }
      </nav>

      @if (draft; as d) {
        <div class="pm__detail">

          @if (isIncomplete(d)) {
            <p class="pm__hint pm__hint--warn">
              <i class="fa-solid fa-circle-info" aria-hidden="true"></i>
              {{ 'PAYMENT_METHODS.INCOMPLETE_HINT' | translate }}
            </p>
          }

          <section class="pm__panel">
            <h2 class="pm__panel-title">{{ 'PAYMENT_METHODS.IDENTITY' | translate }}</h2>
            <div class="pm__fields">
              <label class="pm__field pm__field--narrow">
                <span>{{ 'PAYMENT_METHODS.CODE' | translate }}</span>
                <!-- Le site s'y réfère : figé après création. -->
                <input type="text" [(ngModel)]="d.code" [disabled]="!canWrite || (d.id !== null)"
                       placeholder="bank_transfer" />
              </label>
              <label class="pm__field pm__field--narrow">
                <span>{{ 'PAYMENT_METHODS.KIND' | translate }}</span>
                <select [(ngModel)]="d.kind" [disabled]="!canWrite">
                  @for (kind of kinds; track kind) {
                    <option [value]="kind">
                      {{ ('PAYMENT_METHODS.KIND_' + kind.toUpperCase()) | translate }}
                    </option>
                  }
                </select>
              </label>
              <label class="pm__field pm__field--narrow">
                <span>{{ 'PAYMENT_METHODS.ORDER' | translate }}</span>
                <input type="number" min="1" [(ngModel)]="d.displayOrder" [disabled]="!canWrite" />
              </label>
            </div>

            <div class="pm__fields">
              <label class="pm__field">
                <span>{{ 'PAYMENT_METHODS.LABEL_FR' | translate }}</span>
                <input type="text" [(ngModel)]="d.labelFr" [disabled]="!canWrite" />
              </label>
              <label class="pm__field">
                <span>{{ 'PAYMENT_METHODS.LABEL_AR' | translate }}</span>
                <input type="text" dir="rtl" [(ngModel)]="d.labelAr" [disabled]="!canWrite" />
              </label>
              <label class="pm__field">
                <span>{{ 'PAYMENT_METHODS.LABEL_EN' | translate }}</span>
                <input type="text" [(ngModel)]="d.labelEn" [disabled]="!canWrite" />
              </label>
            </div>
          </section>

          <!-- Coordonnées bancaires : seul le virement en a. -->
          @if (d.kind === 'bank_transfer') {
            <section class="pm__panel">
              <h2 class="pm__panel-title">{{ 'PAYMENT_METHODS.ACCOUNT' | translate }}</h2>
              <p class="pm__hint">{{ 'PAYMENT_METHODS.ACCOUNT_HINT' | translate }}</p>

              <div class="pm__fields">
                <label class="pm__field">
                  <span>{{ 'PAYMENT_METHODS.HOLDER' | translate }}</span>
                  <input type="text" [(ngModel)]="d.accountHolder" [disabled]="!canWrite" />
                </label>
                <label class="pm__field">
                  <span>{{ 'PAYMENT_METHODS.BANK' | translate }}</span>
                  <input type="text" [(ngModel)]="d.bankName" [disabled]="!canWrite" />
                </label>
              </div>
              <div class="pm__fields">
                <label class="pm__field">
                  <span>{{ 'PAYMENT_METHODS.RIB' | translate }}</span>
                  <input type="text" dir="ltr" inputmode="numeric" [(ngModel)]="d.rib" [disabled]="!canWrite" />
                </label>
                <label class="pm__field">
                  <span>{{ 'PAYMENT_METHODS.IBAN' | translate }}</span>
                  <input type="text" dir="ltr" [(ngModel)]="d.iban" [disabled]="!canWrite" />
                </label>
                <label class="pm__field pm__field--narrow">
                  <span>{{ 'PAYMENT_METHODS.BIC' | translate }}</span>
                  <input type="text" dir="ltr" [(ngModel)]="d.bic" [disabled]="!canWrite" />
                </label>
              </div>
            </section>
          }

          <section class="pm__panel">
            <h2 class="pm__panel-title">{{ 'PAYMENT_METHODS.INSTRUCTIONS' | translate }}</h2>
            <p class="pm__hint">{{ 'PAYMENT_METHODS.INSTRUCTIONS_HINT' | translate }}</p>

            <label class="pm__field">
              <span>{{ 'PAYMENT_METHODS.LABEL_FR' | translate }}</span>
              <textarea rows="3" [(ngModel)]="d.instructionsFr" [disabled]="!canWrite"></textarea>
            </label>
            <label class="pm__field">
              <span>{{ 'PAYMENT_METHODS.LABEL_AR' | translate }}</span>
              <textarea rows="3" dir="rtl" [(ngModel)]="d.instructionsAr" [disabled]="!canWrite"></textarea>
            </label>
            <label class="pm__field">
              <span>{{ 'PAYMENT_METHODS.LABEL_EN' | translate }}</span>
              <textarea rows="3" [(ngModel)]="d.instructionsEn" [disabled]="!canWrite"></textarea>
            </label>
          </section>

          <div class="pm__actions">
            <label class="pm__check">
              <input type="checkbox" [(ngModel)]="d.isActive" [disabled]="!canWrite" />
              <span>{{ 'PAYMENT_METHODS.IS_ACTIVE' | translate }}</span>
            </label>

            <span class="pm__actions-spacer"></span>

            <!-- Consultation seule : ni suppression ni enregistrement. -->
            @if (canWrite) {
            @if (d.id !== null) {
              <button type="button" class="pm__btn pm__btn--danger"
                      (click)="remove($any(d))" [disabled]="isSaving">
                <i class="fa-solid fa-trash" aria-hidden="true"></i>
                {{ 'PAYMENT_METHODS.DELETE' | translate }}
              </button>
            } @else {
              <button type="button" class="pm__btn" (click)="cancel()" [disabled]="isSaving">
                {{ 'PAYMENT_METHODS.CANCEL' | translate }}
              </button>
            }
            <button type="button" class="pm__btn pm__btn--primary"
                    (click)="save()" [disabled]="isSaving">
              <i class="fa-solid fa-floppy-disk" aria-hidden="true"></i>
              {{ (isSaving ? 'PAYMENT_METHODS.SAVING' : 'PAYMENT_METHODS.SAVE') | translate }}
            </button>
            }
          </div>
        </div>
      }
    </div>
  }
</div>
